export const ExternalLinks = {
  HelpHomepage: "https://pdview.atlassian.net/wiki/spaces/VOKB/overview"
};

export const ExternalLinkNames = {
  [ExternalLinks.HelpHomepage]: "Help Docs"
};
